import { render, staticRenderFns } from "./SimpleTextInput.vue?vue&type=template&id=a5de4cea&"
import script from "./SimpleTextInput.vue?vue&type=script&lang=js&"
export * from "./SimpleTextInput.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTextInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5de4cea')) {
      api.createRecord('a5de4cea', component.options)
    } else {
      api.reload('a5de4cea', component.options)
    }
    module.hot.accept("./SimpleTextInput.vue?vue&type=template&id=a5de4cea&", function () {
      api.rerender('a5de4cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleTextInput.vue"
export default component.exports